module.exports = __webpack_public_path__ + "img/appointment@2x.9c0f86d.jpg";